<template>
    <svg
        class="edverumLogo"
        :width="dimensions.width"
        :height="dimensions.height"
        :viewBox="viewBox"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <defs>
            <polygon
                id="path-1"
                points="2.11081794e-05 0.0857518248 39.9151451 0.0857518248 39.9151451 43.892944 2.11081794e-05 43.892944"
            />
        </defs>
        <g id="logo/Edverum" stroke="none" class="something" stroke-width="1" fill="none" fill-rule="evenodd">
            <g v-if="!hideText" id="edverum-logo-text" transform="translate(46.000000, -5.000000)" class="logo-text" fill-rule="nonzero">
                <path
                    id="Edverum"
                    d="M18.38,19.08 L8.57,19.08 L8.57,23.31 L17.57,23.31 L17.57,27.39 L8.57,27.39 L8.57,31.92 L18.38,31.92 L18.38,36 L4.28,36 L4.28,15 L18.38,15 L18.38,19.08 Z M32.9666667,12.9 L37.2566667,12.9 L37.2566667,36 L32.9666667,36 L32.9666667,33.78 C31.8266667,35.34 30.0866667,36.36 27.7766667,36.36 C23.4866667,36.36 20.2466667,32.82 20.2466667,27.75 C20.2466667,22.65 23.5166667,19.14 27.7466667,19.14 C30.0866667,19.14 31.8266667,20.22 32.9666667,21.81 L32.9666667,12.9 Z M28.7366667,32.28 C31.1366667,32.28 32.9666667,30.48 32.9666667,27.75 C32.9666667,25.05 31.1366667,23.22 28.7366667,23.22 C26.3366667,23.22 24.5666667,25.05 24.5666667,27.75 C24.5666667,30.48 26.3666667,32.28 28.7366667,32.28 Z M50.7033333,19.5 L55.2633333,19.5 L49.5933333,36 L44.4633333,36 L38.7933333,19.5 L43.3533333,19.5 L47.0133333,31.35 L50.7033333,19.5 Z M63.97,19.14 C69.43,19.14 72.82,23.43 72.4,28.86 L59.74,28.86 C60.01,31.5 61.81,32.82 64.03,32.82 C65.68,32.82 67.12,32.07 67.69,30.75 L72.13,30.75 C70.9,34.65 67.6,36.36 64.06,36.36 C58.9,36.36 55.36,32.7 55.36,27.78 C55.36,22.83 58.93,19.14 63.97,19.14 Z M63.94,22.68 C61.84,22.68 60.49,23.94 59.95,25.71 L67.84,25.71 C67.36,23.91 66.01,22.68 63.94,22.68 Z M83.9266667,19.14 C84.3166667,19.14 84.6166667,19.17 84.8866667,19.2 L84.8866667,23.61 C84.5566667,23.58 84.3166667,23.55 83.8366667,23.55 C81.1066667,23.55 78.7666667,24.75 78.7666667,28.65 L78.7666667,36 L74.4766667,36 L74.4766667,19.5 L78.7666667,19.5 L78.7666667,22.38 C79.7866667,20.22 81.5866667,19.14 83.9266667,19.14 Z M97.2233333,19.5 L101.513333,19.5 L101.513333,36 L97.2233333,36 L97.2233333,33.72 C96.0233333,35.4 94.4033333,36.36 92.1233333,36.36 C88.4933333,36.36 86.2433333,33.87 86.2433333,29.85 L86.2433333,19.5 L90.5333333,19.5 L90.5333333,28.92 C90.5333333,31.08 91.3433333,32.28 93.5633333,32.28 C95.9333333,32.28 97.2233333,30.87 97.2233333,28.17 L97.2233333,19.5 Z M123.81,19.14 C127.32,19.14 129.51,21.57 129.51,25.56 L129.51,36 L125.22,36 L125.22,26.49 C125.22,24.39 124.44,23.22 122.37,23.22 C120.12,23.22 118.95,24.72 118.95,27.33 L118.95,36 L114.66,36 L114.66,26.49 C114.66,24.39 113.88,23.22 111.81,23.22 C109.56,23.22 108.36,24.72 108.36,27.33 L108.39,36 L104.07,36 L104.07,19.5 L108.39,19.5 L108.39,21.69 C109.56,20.04 111.12,19.14 113.28,19.14 C115.65,19.14 117.39,20.25 118.29,22.26 C119.49,20.31 121.38,19.14 123.81,19.14 Z"
                />
            </g>
            <g id="logo/Icon" class="something" transform="translate(-2.000000, 0.000000)">
                <g id="logo/Owlie" transform="translate(2.000000, 0.000000)">
                    <g id="Owlie">
                        <g id="Group-3" transform="translate(0.000000, 0.021304)">
                            <mask id="mask-2" fill="white">
                                <use xlink:href="#path-1" />
                            </mask>
                            <g id="Clip-2" />
                            <path
                                id="Fill-1"
                                class="logo-primary"
                                d="M19.9575937,27.8727153 C18.840971,22.5639173 14.8286227,19.9802287 14.8286227,19.9802287 C17.026723,17.6799173 19.9575937,17.4499611 19.9575937,17.4499611 C19.9575937,17.4499611 22.8884644,17.6799173 25.0866702,19.9802287 C25.0866702,19.9802287 21.0740053,22.5639173 19.9575937,27.8727153 M39.9151662,25.1828273 L39.8987018,25.1017859 C38.5316306,25.91691 36.9400739,26.3862433 35.2395989,26.3862433 C30.1522111,26.3862433 26.0284116,22.2031387 26.0284116,17.0428273 C26.0284116,11.8824088 30.1522111,7.69930414 35.2395989,7.69930414 C35.7249815,7.69930414 36.2012876,7.73795134 36.6666174,7.81128467 C38.4933193,5.05941119 36.914533,1.18741119 36.914533,1.18741119 C35.9375409,4.01861314 32.4484644,4.58483212 32.4484644,4.58483212 C26.5169604,-0.228403893 19.9575937,0.0900875912 19.9575937,0.0900875912 C19.9575937,0.0900875912 13.3980158,-0.228403893 7.46661741,4.58483212 C7.46661741,4.58483212 3.9775409,4.01861314 3.00065435,1.18741119 C3.00065435,1.18741119 1.42165699,5.05941119 3.24856992,7.81128467 C3.71358311,7.73795134 4.18999472,7.69930414 4.67548285,7.69930414 C9.76265963,7.69930414 13.8865646,11.8824088 13.8865646,17.0428273 C13.8865646,22.2031387 9.76265963,26.3862433 4.67548285,26.3862433 C2.97490237,26.3862433 1.38324011,25.91691 0.0161688654,25.1017859 L2.11081794e-05,25.1828273 C2.11081794e-05,25.1828273 2.65184169,31.1992652 6.41996834,32.4734453 C6.41996834,32.4734453 4.74513984,32.7565012 3.83791029,32.4734453 C3.83791029,32.4734453 6.00118206,36.5080633 9.62988918,38.3485693 C9.62988918,38.3485693 9.14144591,39.1981655 8.44350396,39.5519854 C8.44350396,39.5519854 17.6547968,41.5806959 19.9575937,43.8929976 C22.2603905,41.5806959 31.4716834,39.5519854 31.4716834,39.5519854 C30.7735303,39.1981655 30.2851926,38.3485693 30.2851926,38.3485693 C33.9137942,36.5080633 36.0768549,32.4734453 36.0768549,32.4734453 C35.169942,32.7565012 33.4951135,32.4734453 33.4951135,32.4734453 C37.2633456,31.1992652 39.9151662,25.1828273 39.9151662,25.1828273"
                                mask="url(#mask-2)"
                            />
                        </g>
                        <path
                            id="Fill-4"
                            class="logo-primary"
                            d="M8.68795778,14.4097217 C10.7990923,14.4097217 12.5525488,15.9511134 12.922153,17.9842131 C12.9357678,17.8146365 12.9446332,17.6438822 12.9446332,17.471201 C12.9446332,14.0406998 10.2031029,11.2597071 6.82125594,11.2597071 C3.43930343,11.2597071 0.697984169,14.0406998 0.697984169,17.471201 C0.697984169,20.901381 3.43930343,23.6822667 6.82125594,23.6822667 C7.76584697,23.6822667 8.65998945,23.4649431 9.4588285,23.0777217 C9.20827441,23.1236487 8.9514934,23.1515903 8.68795778,23.1515903 C6.30811609,23.1515903 4.37893404,21.1943932 4.37893404,18.7806024 C4.37893404,16.3664905 6.30811609,14.4097217 8.68795778,14.4097217"
                        />
                        <path
                            id="Fill-6"
                            class="logo-primary"
                            d="M31.2270712,23.1515582 C30.9635356,23.1515582 30.7066491,23.1236165 30.4559894,23.0777966 C31.2551451,23.4649109 32.1491821,23.6822345 33.0937731,23.6822345 C36.4755145,23.6822345 39.2171504,20.9013489 39.2171504,17.4711689 C39.2171504,14.0406676 36.4755145,11.2596749 33.0937731,11.2596749 C29.7119261,11.2596749 26.9707124,14.0406676 26.9707124,17.4711689 C26.9707124,17.6439572 26.9791557,17.8146044 26.9931926,17.984181 C27.3623747,15.9510813 29.1157256,14.4096895 31.2270712,14.4096895 C33.6069129,14.4096895 35.5359894,16.3664584 35.5359894,18.7805703 C35.5359894,21.1943611 33.6069129,23.1515582 31.2270712,23.1515582"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'EdverumLogo',

    props: {
        size: {
            type: String,
            default: 'medium',
            validator: value => ['small', 'medium', 'large'].includes(value),
        },
        hideText: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        /**
         * @returns {string}
         */
        colorText() {
            return '#242B36'; // TODO
        },

        /**
         * @returns {string}
         */
        viewBox() {
            // When hiding text, only show the icon portion (square area)
            if (this.hideText) {
                return '0 0 44 44';
            }
            // Full logo with text
            return '0 0 176 44';
        },

        /**
         * @returns {{ width: string, height: string }}
         */
        dimensions() {
            if (this.hideText) {
                // Icon only - square dimensions
                const iconSizes = {
                    small: { width: '22px', height: '22px' },
                    medium: { width: '44px', height: '44px' },
                    large: { width: '66px', height: '66px' },
                };
                return iconSizes[this.size];
            }

            // Full logo with text
            const sizes = {
                small: { width: '88px', height: '22px' },
                medium: { width: '176px', height: '44px' },
                large: { width: '264px', height: '66px' },
            };

            return sizes[this.size];
        },
    },
};
</script>

<style lang="scss">
@import 'resources/scss/toolbox.scss';

.edverumLogo {
    background-color: transparent;
    path {
        transition: $transition-medium;
    }
    .logo-primary {
        fill: #335ce5; // Edverum brand blue — stays constant regardless of selected theme color
    }
    .logo-text {
        fill: var(--p-text-color);
    }
}
</style>
